import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import DateTimePicker from '@/components/DSE/DateTimePicker';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    productID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.product',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['product/isLoading'],
        options: vue.$store.getters['product/loadedItems'],
        disabled: true
      }
    },
    salePrice: {
      type: MDinput,
      props: {
        type: 'currency',
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    dateOnSaleFrom: {
      type: DateTimePicker,
      props: {
        caption: 'common.dateOnSaleFrom',
        type: 'datetime',
        format: vue.$store.getters.dateTimeFormat,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    dateOnSaleTo: {
      type: DateTimePicker,
      props: {
        caption: 'common.dateOnSaleTo',
        type: 'datetime',
        format: vue.$store.getters.dateTimeFormat,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    domainID: {
      type: Select,
      props: {
        caption: 'common.domain',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['domain/isLoading'],
        options: vue.$store.getters['domain/loadedItems']
      }
    },
    customerID: {
      type: Select,
      props: {
        caption: 'common.customer',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['customer/isLoading'],
        options: vue.$store.getters['customer/loadedItems']
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
